 export const BaseUrl = {
    'UAT':`https://mdqualityapps.in/API/shopztrend/UAT/`,
    'Live':`https://shopztrend.com/ProdApiFolder/`,
 }